import React from 'react';
import {useDispatch} from "react-redux";
import { Animate } from "react-simple-animate";
import {
    setWatchOffCanvasIsActive,
    setReadOffCanvasIsActive,
    setLearnOffCanvasIsActive,
    setWatchIsActive,
} from "../../../Features/Misc/navBarSlice";
import {
    setActiveWatch,
    setActiveLearn,
    setActiveRead,
    setDashBoardIsActive

} from "../../../Features/Misc/activeSlice";
import FaveHeart from "../../Components/FaveHeart";



const SearchResultCard = ({ imgSrc: imageUrl, title,  date: videoPostedDate, content, type, id, authorName, vidLink, mediaId, mediaType, }) => {
    const dispatch = useDispatch();


    const handleClick = (e) => {
        e.preventDefault()


        const payload = {
            imgSrc: imageUrl,
            title,
            text: content,
            date: videoPostedDate,
            type,
            id,
            authorName,
            vidLink,
            mediaType


        };

        switch (type) {
            case 'watches':

                dispatch(setWatchOffCanvasIsActive());
                dispatch(setActiveWatch(payload));
                dispatch(setDashBoardIsActive())


                break;
            case 'reads':
                dispatch(setReadOffCanvasIsActive());
                dispatch(setActiveRead(payload));
                dispatch(setDashBoardIsActive())
                break;
            case 'learns':
                dispatch(setLearnOffCanvasIsActive());
                dispatch(setActiveLearn(payload));
                dispatch(setDashBoardIsActive())
                break;
            default:
                console.error('Unknown type:', type);
        }
    };

    const displayName = authorName ? (authorName === 'wesley@hydra' ? 'Sleep Geek' : authorName) : 'Sleep Geek';


    return (
        <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>

        {/*<div onClick={handleClick} className="border border-gold-accent rounded-lg p-4 lg:flex lg:space-x-10 space-y-5 lg:space-y-0 cursor-pointer">*/}
        {/*    <div className="flex-grow-0 flex-shrink-0 relative">*/}
        {/*        <div className="relative inline-block" style={{ maxWidth: '275px', minHeight: "200px" }}>*/}
        {/*            <img className="rounded w-full lg:w-auto" src={imageUrl || "https://placeholder.co/275x225"} alt="" style={{ maxWidth: '275px', minHeight: "200px" }} />*/}
        {/*            <span className="cursor-pointer absolute top-2 right-2">*/}
        {/*                <FaveHeart type={"Learn"} mediaId={mediaId} mediaType={mediaType} />*/}
        {/*            </span>*/}
        {/*        </div>*/}
        {/*    </div>*/}

        {/*    <div className="text-white">*/}
        {/*        <h3 className="text-lg mb-1 font-semibold mt-3">{title || "Support Across A Full Season"}</h3>*/}
        {/*        <p className="hidden md:block">{content.substring(0, 350).replace(/(<([^>]+)>)/gi, "")}...</p>*/}
        {/*    </div>*/}

        {/*    <div className="flex-grow-0 flex-shrink-0 flex flex-col">*/}
        {/*        <div className="flex-1 rounded-t-lg bg-light-pink text-purple-slumber flex items-center px-8 pt-5 pb-6 -mb-2">*/}
        {/*            {type === "watches" && <i className="ri-video-line text-xl mr-4"></i>}*/}
        {/*            {type === "reads" && <i className="ri-book-read-line text-xl mr-4"></i>}*/}
        {/*            {type === "learns" && <i className="ri-lightbulb-line text-xl mr-4"></i>}*/}

        {/*            {type === "watches" && <p className="font-semibold">Video</p> }*/}
        {/*            {type === "reads" && <p className="font-semibold">Article</p> }*/}
        {/*            {type === "learns" && <p className="font-semibold">Webinar</p> }*/}
        {/*        </div>*/}
        {/*        <div className="flex-1 rounded-t-lg bg-pink-dashboard text-white flex items-center px-8 pt-5 pb-6 -mb-2">*/}
        {/*            {type === "watches" && <i className="ri-video-line text-xl mr-4 text-gold-accent"></i> }*/}
        {/*            {type === "reads" && <i className="ri-book-read-line text-xl mr-4 text-gold-accent"></i> }*/}
        {/*            {type === "learns" && <i className="ri-lightbulb-line text-xl mr-4 text-gold-accent"></i> }*/}
        {/*            <p className="text-sm">{displayName} <span className="block">{videoPostedDate ? videoPostedDate.substring(0, 10) : "1 day ago"}</span></p>*/}
        {/*        </div>*/}
        {/*        <div className="flex-1 cursor-pointer rounded-lg bg-white text-purple flex justify-between items-center px-8 py-5 font-semibold">*/}
        {/*            {type === "watches" && <p className="mb-0 font-semibold">Watch Now</p> }*/}
        {/*            {type === "reads" && <p className="mb-0 font-semibold">Read Now</p> }*/}
        {/*            {type === "learns" && <p className="mb-0 font-semibold">Watch Now</p> }*/}
        {/*            <i className="ri-arrow-right-line ml-3 text-gold-accent"></i>*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*</div>*/}


            <div onClick={handleClick} className="border border-gold-accent rounded-lg p-4 lg:flex lg:space-x-10 space-y-5 lg:space-y-0 cursor-pointer">
                <div className="flex-grow-0 flex-shrink-0 relative">
                    <div className="relative inline-block" style={{ maxWidth: '275px', minHeight: "200px" }}>
                        <img className="rounded w-full lg:w-auto" src={imageUrl || "https://placeholder.co/275x225"} alt="" style={{ maxWidth: '275px', minHeight: "200px" }} />
                        <span className="cursor-pointer absolute top-2 right-2">
                <FaveHeart type={"Learn"} mediaId={mediaId} mediaType={mediaType} />
            </span>
                    </div>
                </div>

                <div className="flex-grow text-white min-h-[200px]"> {/* Ensuring minimum height for the middle child */}
                    <h3 className="text-lg mb-1 font-semibold mt-3">{title || "Support Across A Full Season"}</h3>
                    <p className="hidden md:block">{content.substring(0, 350).replace(/(<([^>]+)>)/gi, "")}...</p>
                </div>

                <div className="flex-grow-0 flex-shrink-0 flex flex-col">
                    {/* Last child with flex-grow-0 to prevent it from growing too much */}
                    <div className="flex-1 rounded-t-lg bg-light-pink text-purple-slumber flex items-center px-8 pt-5 pb-6 -mb-2">
                        {type === "watches" && <i className="ri-video-line text-xl mr-4"></i>}
                        {type === "reads" && <i className="ri-book-read-line text-xl mr-4"></i>}
                        {type === "learns" && <i className="ri-lightbulb-line text-xl mr-4"></i>}

                        {type === "watches" && <p className="font-semibold">Video</p> }
                        {type === "reads" && <p className="font-semibold">Article</p> }
                        {type === "learns" && <p className="font-semibold">Webinar</p> }
                    </div>
                    <div className="flex-1 rounded-t-lg bg-pink-dashboard text-white flex items-center px-8 pt-5 pb-6 -mb-2">
                        {type === "watches" && <i className="ri-video-line text-xl mr-4 text-gold-accent"></i> }
                        {type === "reads" && <i className="ri-book-read-line text-xl mr-4 text-gold-accent"></i> }
                        {type === "learns" && <i className="ri-lightbulb-line text-xl mr-4 text-gold-accent"></i> }
                        <p className="text-sm">{displayName} <span className="block">{videoPostedDate ? videoPostedDate.substring(0, 10) : "1 day ago"}</span></p>
                    </div>
                    <div className="flex-1 cursor-pointer rounded-lg bg-white text-purple flex justify-between items-center px-8 py-5 font-semibold">
                        {type === "watches" && <p className="mb-0 font-semibold">Watch Now</p> }
                        {type === "reads" && <p className="mb-0 font-semibold">Read Now</p> }
                        {type === "learns" && <p className="mb-0 font-semibold">Watch Now</p> }
                        <i className="ri-arrow-right-line ml-3 text-gold-accent"></i>
                    </div>
                </div>
            </div>


        </Animate>
    );
};

export default SearchResultCard;